import axios from "axios";
import { SSO_COOKIE_SENTINEL } from "./ginjaAuth";
import { getDevBearerToken } from "./devBearer";

export const baseUrl = "https://service.ginja.ai/sandbox/api/v1";

// Send the .ginja.ai HttpOnly SSO cookie on every cross-origin request.
// Requires backend CORS: Allow-Origin (explicit) + Allow-Credentials: true.
axios.defaults.withCredentials = true;

// If we're authed via the HttpOnly cookie, we don't have a real JWT to put in
// the Authorization header — legacy code still adds `Bearer <sentinel>` though.
// Strip any invalid Bearer header before the request goes out so the backend
// auths via cookie instead of trying to validate the sentinel as a JWT.
const stripIfSentinel = (headers) => {
  if (!headers) return;
  const isSentinel = (v) =>
    typeof v === "string" && v.toLowerCase().includes(SSO_COOKIE_SENTINEL.toLowerCase());
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === "authorization" && isSentinel(headers[key])) {
      delete headers[key];
    }
  }
};

let devBearerLogged = false;

axios.interceptors.request.use((config) => {
  stripIfSentinel(config.headers);
  stripIfSentinel(config.headers?.common);
  stripIfSentinel(config.headers?.[config.method?.toLowerCase()]);

  const devToken = getDevBearerToken();
  if (devToken) {
    if (typeof config.headers === "object" && config.headers !== null) {
      config.headers.Authorization = `Bearer ${devToken}`;
    } else {
      config.headers = { Authorization: `Bearer ${devToken}` };
    }
    if (!devBearerLogged && typeof console !== "undefined") {
      devBearerLogged = true;
      console.info(
        "[api] REACT_APP_DEV_BEARER_TOKEN is active (development only; remove for deploy).",
      );
    }
  }

  return config;
});
